































import { Vue, Component, Prop } from "vue-property-decorator";
import api, { learningRequestApi } from "@/getinfo-api";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import draggable from "vuedraggable";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import TestSortQuestionsItem from "@/components/tests/testSortQuestionsItem.vue";
import { uniqBy } from "lodash";

@Component({
  components: {
    TestSortQuestionsItem,
    CustomButton,
    CField,
    CustomTable,
    CustomTableCol,
    CustomTableItem,
    draggable
  }
})
export default class TestSortQuestions extends Vue {
  @Prop() testId!: string;
  questions: Array<ITestQuestion> = [];
  offset: number = 0;
  limit: number = 100;
  count: number = 0;
  isSortedInProcess: boolean = false;
  isChangeWeight: boolean = false;
  isLoading: boolean = false;

  async getQuestions() {
    await api.TestApi.listQuestions(this.testId, this.offset, this.limit).then(
      async res => {
        this.count = res.data.count;
        this.questions = [...this.questions, ...res.data.questions];
        if (this.count > this.questions.length + 1) {
          this.offset += this.limit;
          await this.getQuestions();
        }
      }
    );
  }

  async init() {
    this.isLoading = true;
    await this.getQuestions();
    console.log(this.questions.map(({ id }) => id));
    this.isLoading = false;
  }

  changeOrder(params: { id: string; index: number; order: number }) {
    let question = this.questions[params.index];
    this.questions.splice(params.index, 1);
    this.questions.splice(params.order - 1, 0, question);
    this.sortQuestionsOrder();
  }

  async sortQuestionsOrder() {
    try {
      this.isSortedInProcess = true;
      await api.TestApi.sortQuestions(
        this.testId,
        this.questions.map(({ id }) => id)
      );
      this.$bvToast.toast(this.$tc(this.$translate.SortingHasBeenChanged), {
        variant: "success",
        title: this.$tc(this.$translate.Successful)
      });
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.isSortedInProcess = false;
    }
  }

  created() {
    this.init();
  }
}
